export default "assets/picto-ab-48b309a8.png";